export const OVERLAY_TEXT_MAX_LENGTH = 50;

const unwrapJsonString = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed.startsWith('"')) {
    return value;
  }
  try {
    const parsed = JSON.parse(trimmed);
    return typeof parsed === 'string' ? parsed : value;
  } catch {
    return value;
  }
};

export const toOverlayText = (value?: string | null): string => {
  if (!value) {
    return '';
  }
  return unwrapJsonString(value)
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/\s+/g, ' ')
    .trim();
};

export const resolveOverlayText = (
  value: string | null | undefined,
  fallback: string
): string => {
  const text = toOverlayText(value);
  return text && text.length <= OVERLAY_TEXT_MAX_LENGTH ? text : fallback;
};
